import * as React from "react";

import "./restrict-length-warning.scss";

export const RestrictLengthWarning = ({restrict: {maxLength, message}, currentLength, xdQaName}) => (
    <div className="restrict-length-warning-61o">
        <div className="message">
            {currentLength > maxLength && message}
        </div>
        <div className="sum" xd-qa-type="label" xd-qa-name={`${xdQaName} Character Counter`}>
            {currentLength}
        </div>
    </div>
);
